import { TextType } from 'ui-components/components/text';

import { ActionableRateCard } from '../../rate-card/actionable/actionable-rate-card';
import { CreateReturnLabelButton } from '../components/create-return-label-button';
import { useReturnConfig } from '../return-config-provider';

import { messages } from './messages';
import styles from './styles.module.less';

export function ReturnRateCard() {
  const { isInternationalReturn } = useReturnConfig();

  return (
    <ActionableRateCard
      ActionButton={CreateReturnLabelButton}
      carrierLogoClassName={styles['carrier-logo']}
      disabledMessage={isInternationalReturn ? messages.internationalReturn : null}
      hideCostReview
      isDisabled={isInternationalReturn}
      rateAmountTextType={TextType.H4}
      refreshIconClassName={styles['rate-refresh-icon']}
    />
  );
}
